import {
  AvatarFramePng,
  AvatarFrameVipPng,
  VipBadgeFramePng,
  UsernameFramePng,
  UsernameFrameDownLightPng,
  AvatarFrameSparklePng,
  ProfileLevelFramePng,
  ProfileImage,
} from "../../../assets";
import { Image, ImageBackground, Platform, Text } from "react-native";
import avatarPng from "../../../assets/profile/avatar.png";
import React from "react";
import {
  AvatarLevelPosition,
  AvatarSparklePosition,
} from "../../../../typings/types";
import { vars } from "../../../utils/helpers/vars";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getAvatarUrl } from "../../../utils/axiosInstance";
import { useDevice } from "../../../utils/hooks/useDevice";

const AvatarFrame = ({
  hasGradient,
  levelPosition,
  sparklePosition,
  showVipBadge,
  showUsernameFrame,
  sizeMultiplier = 1,
}: {
  hasGradient?: boolean;
  levelPosition?: AvatarLevelPosition;
  sparklePosition?: AvatarSparklePosition;
  showVipBadge?: boolean;
  showUsernameFrame?: boolean;
  sizeMultiplier?: number;
}) => {
  const player = useSelector((s: RootState) => s.auth.user);
  const isNative = Platform.OS !== "web";
  // const level = useSelector((s: RootState) => s.auth.statistics?.level.current);
  const isDesktop = useDevice();
  return (
    <ImageBackground
      source={player?.isVip ? AvatarFrameVipPng : AvatarFramePng}
      style={{
        top: hasGradient ? 20 * sizeMultiplier : 0,
        left: hasGradient ? 20 * sizeMultiplier : 0,
        width: 63 * sizeMultiplier,
        height: 63 * sizeMultiplier,
      }}
    >
      {/*SPARKLE*/}
      {!!sparklePosition && (
        <Image
          source={AvatarFrameSparklePng}
          style={
            sparklePosition === AvatarSparklePosition.Left
              ? {
                  position: "absolute",
                  zIndex: 1,
                  width: 35 * sizeMultiplier,
                  height: 35 * sizeMultiplier,
                  top: -8 * sizeMultiplier,
                  left: -8 * sizeMultiplier,
                }
              : {
                  // todo
                  display: "none",
                }
          }
        />
      )}

      {/*LEVEL*/}
      {!!levelPosition && (
        <ImageBackground
          source={ProfileLevelFramePng}
          style={
            levelPosition === AvatarLevelPosition.TopRight
              ? {
                  position: "absolute",
                  zIndex: 1,
                  width: 29 * sizeMultiplier,
                  height: 29 * sizeMultiplier,
                  top: -1 * sizeMultiplier,
                  right: -7 * sizeMultiplier,
                }
              : {
                  //todo
                  display: "none",
                }
          }
        >
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              width: "100%",
              height: "100%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#fff",
              fontSize: 14,
              fontWeight: "bold",
              paddingTop: isNative ? -2 : 4,
              top: isDesktop ? 0 : -3,
            }}
          >
            {player?.level ? player.level : 1}
          </Text>
        </ImageBackground>
      )}

      {/*AVATAR*/}
      {/* <Image
        source={avatarPng}
        style={{
          position: "absolute",
          width: 55 * sizeMultiplier,
          height: 55 * sizeMultiplier,
          top: 4 * sizeMultiplier,
          left: 4 * sizeMultiplier,
        }}
      /> */}
      {(() => {
        const avatarUri =
          player?.avatarFileId && typeof player.avatarFileId === "string"
            ? getAvatarUrl(player.avatarFileId)
            : undefined;
        const avatarSource = avatarUri ? { uri: avatarUri } : ProfileImage;

        return (
          <Image
            source={avatarSource}
            style={{
              position: "absolute",
              width: 55 * sizeMultiplier,
              height: 55 * sizeMultiplier,
              top: 4 * sizeMultiplier,
              left: 4 * sizeMultiplier,
              borderRadius: (55 * sizeMultiplier) / 2,
            }}
            resizeMode="cover"
          />
        );
      })()}

      {/*VIP BADGE*/}
      {showVipBadge && (
        <Image
          source={VipBadgeFramePng}
          style={{
            position: "absolute",
            top: 28,
            left: 42,
            width: 27,
            height: 27,
          }}
        />
      )}

      {/*USERNAME FRAME*/}
      {showUsernameFrame && (
        <ImageBackground
          source={UsernameFramePng}
          style={{
            position: "absolute",
            justifyContent: "center",
            top: 80,
            left: 4,
            width: 91,
            height: 26,
          }}
        >
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              textAlign: "center",
              color: "white",
              fontSize: 12,
              fontWeight: "bold",
              paddingBottom: 4,
            }}
          >
            {player?.username ? player.username : "User"}
          </Text>
          <Image
            source={UsernameFrameDownLightPng}
            style={{
              position: "absolute",
              top: 13,
              left: -43,
              width: 180,
              height: 25,
            }}
          />
        </ImageBackground>
      )}
    </ImageBackground>
  );
};
export default AvatarFrame;
